const nameData = "rubros"; // Define la entidad dinámica
const nameDataSingular = "rubro"; // Para el caso singular

export const fetchEntityData = async (getEntityPanelData, searchTerm,searchIDFilter, numPagina, filas) => {
  try {
    const data = await getEntityPanelData(searchTerm, searchIDFilter,numPagina, filas);
    if (data) {
      const totalPage = data.pagination.totalPage || 1;
      const totalDataItems = data.pagination.totalItems || 0;
      return {
        dataEntity: data[nameData] || [], // Usa nameData dinámicamente
        totalItems: data.pagination.totalItems || 0,
        totalPage,
        totalDataItems
      };
    }
  } catch (error) {
    console.error(`Error al cargar ${nameData}:`, error);
    throw error;
  }
};

export const deleteItem = async (deleteEntityData, selectedItem) => {
  try {
    await deleteEntityData(selectedItem);
  } catch (error) {
    console.error(`Error al eliminar el ${nameDataSingular}:`, error);
    throw error;
  }
};
